module.exports = __webpack_public_path__ + "static/media/cv4.e5311607.png";